module.exports = __webpack_public_path__ + "static/image_16_thumb-4b8ae8d9a55f969b2c7c2c274a0c2ea1.jpg";